// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var inject = allVue.inject;
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, clear } from '../messages';
/**
 * Represents the default `ClearButton` component.
 */

var ClearButton = {
  name: 'clear-button',
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  methods: {
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
    },
    onClickHandler: function onClickHandler(e) {
      this.$emit('clearclick', e);
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var title = provideLocalizationService(this).toLanguageString(clear, messages[clear]);
    return h("span", {
      "class": "k-icon k-clear-value k-i-close",
      role: "button",
      attrs: this.v3 ? undefined : {
        role: "button",
        tabIndex: -1,
        title: title
      },
      onClick: this.onClickHandler,
      on: this.v3 ? undefined : {
        "click": this.onClickHandler,
        "mousedown": this.onMouseDown
      },
      onMousedown: this.onMouseDown,
      tabIndex: -1,
      title: title,
      key: "clearbutton"
    });
  }
};
export { ClearButton };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-dropdowns/dist/es/common/ClearButton.js
// module id = 225
// module chunks = 93